<template>
    <form @submit.prevent="onUpdate(data)" class="card">
        <div class="card-body">
            <h5 class="card-title fw-semibold mb-4">Configuración de aplicación web</h5>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Nombre de aplicación : <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" name="app_name" v-model="data.app_name"
                            placeholder="Ejemplo">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Icono : <span class="text-danger">*</span></label>
                        <v-file-input v-model="data.file" class="form-control d-flex" placeholder="Seleccionar imagen"
                            outlined hide-details accept="image/*" dense>
                        </v-file-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-success rounded-pill px-4">
                <span v-if="count > 0" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span :class="{ 'visually-hidden': count > 0 }">
                    <i class="ti ti-device-floppy me-1 fs-4"></i> Guardar cambios
                </span>
            </button>
        </div>
    </form>
</template>
<script>
export default {
  data () {
    return {
      data: {},
      count: 0
    }
  },
  created () {
    this.onInit()
  },
  methods: {
    onInit: function () {
      this.$axios({
        url: '/app/settings',
        method: 'GET'
      })
        .then((resp) => {
          this.data = resp.data
        })
    },
    onUpdate: function (data) {
      this.count++
      if (this.count !== 1) {
        return
      }
      let form = new FormData()
      this.$.each(data, function (key, item) {
        if (item != null) {
          form.append(key, item)
        }
      })
      this.$axios({
        url: '/app/settings',
        method: 'POST',
        data: form
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .finally((resp) => {
          this.count = 0
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/config/App.vue